// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {OpAck} from './op-ack.js'

export class AcknowledgeAppendedOpsEvent {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): AcknowledgeAppendedOpsEvent {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsAcknowledgeAppendedOpsEvent(
    bb: flatbuffers.ByteBuffer,
    obj?: AcknowledgeAppendedOpsEvent
  ): AcknowledgeAppendedOpsEvent {
    return (obj || new AcknowledgeAppendedOpsEvent()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsAcknowledgeAppendedOpsEvent(
    bb: flatbuffers.ByteBuffer,
    obj?: AcknowledgeAppendedOpsEvent
  ): AcknowledgeAppendedOpsEvent {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new AcknowledgeAppendedOpsEvent()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  acks(index: number, obj?: OpAck): OpAck | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset
      ? (obj || new OpAck()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!)
      : null
  }

  acksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startAcknowledgeAppendedOpsEvent(builder: flatbuffers.Builder) {
    builder.startObject(1)
  }

  static addAcks(builder: flatbuffers.Builder, acksOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, acksOffset, 0)
  }

  static createAcksVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startAcksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static endAcknowledgeAppendedOpsEvent(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // acks
    return offset
  }

  static createAcknowledgeAppendedOpsEvent(
    builder: flatbuffers.Builder,
    acksOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    AcknowledgeAppendedOpsEvent.startAcknowledgeAppendedOpsEvent(builder)
    AcknowledgeAppendedOpsEvent.addAcks(builder, acksOffset)
    return AcknowledgeAppendedOpsEvent.endAcknowledgeAppendedOpsEvent(builder)
  }
}
